import { DocumentPage } from 'src/components';
import { getEnvByName } from 'src/utils';

const userDomain = getEnvByName('VITE_DOWNLOAD_USER_DOMAIN') ?? '';

const EulaYu = (): JSX.Element => {
  return (
    <DocumentPage>
      <h1>End-User License Agreement</h1>
      <p>
        IMPORTANT – READ CAREFULLY: This End-User License Agreement (
        <b>“EULA”</b> or the &quot;License Agreement&quot;) is a legal agreement
        between you (either an individual or a single entity) and Infinity Labs
        R&amp;D Ltd. (<b>“Infinity”</b>) for the Software(s) (as defined below).
        By installing or using the Software, you agree to be bound by the terms
        of this EULA. If you do not agree to the terms of this EULA, do not
        install or use the Software.
      </p>
      <h2>Definitions </h2>
      <p>
        All defined terms in this License Agreement shall have the meaning
        assigned to them herein.
      </p>
      <ol>
        <li>
          <b>“Intellectual Property Rights”</b> means all intangible legal
          rights, titles and interests evidenced by or embodied in all: (i)
          inventions (regardless of patentability and whether or not reduced to
          practice), improvements thereto, patents, patent applications, patent
          disclosures, together with all reissuances, continuations,
          continuations in part, revisions, extensions and reexaminations
          thereof; (ii) trademarks, service marks, trade dress, logos, trade
          names, corporate names, together with translations, adaptations,
          derivations and combinations thereof, including know-how or goodwill
          associated therewith, and applications, registrations, and renewals in
          connection therewith; (iii) any work of authorship, regardless of
          copyrightable, copyrightable works, copyrights (including droit
          morale), and applications, registrations and renewals in connection
          therewith; (iv) mask works and applications, registrations and
          renewals in connection therewith; (v) trade secrets and confidential
          information; and (vi) other proprietary rights and any other similar
          rights, in each case on a worldwide basis, and copies and tangible
          embodiments thereof, in whatever form or medium including confidential
          information, all industrial and intellectual property rights, and
          includes any patents, inventions, business names, domain names,
          registered designs, copyright (including future copyright), moral
          rights, trade or service marks (whether registered or unregistered),
          trade secrets, know-how, rights in relation to circuit layouts, or
          other proprietary right, and applications for, and rights to apply
          for, registration of any of the foregoing and any renewals, reissues,
          extensions, continuations or divisions thereof, and all other
          intellectual property rights and equivalent or similar forms of
          protection now or hereafter existing anywhere in the world.
        </li>
        <li>
          <b>“Software”</b> means the object code version of Infinity&apos;s
          proprietary software provided with this EULA, related documentation,
          user manuals, and Updates, and all other written and or electronic
          materials relating thereto.
        </li>
        <li>
          <b>“Updates”</b> means, with respect to any element of the Software, a
          new version of such element that includes bug fixes and minor
          enhancements to the Software, as designated by a progression of the
          version number right of the decimal point following the version
          initially delivered hereunder, and which is made available at no
          additional cost by Infinity to its customers generally.
        </li>
      </ol>
      <h2>License Grant</h2>
      <ol>
        <li>
          Subject to the terms set forth in this License Agreement, , Infinity
          hereby grants you and you accept, during the term of this License
          Agreement, a non-exclusive, non-transferable, non-sublicensable,
          revocable, limited license right to use the Software for the purpose
          of your internal use purpose only (the &quot;License&quot;).
        </li>
      </ol>
      <h2>Reservation of Rights; Use Restrictions</h2>
      <ol>
        <li>
          Other than the rights explicitly granted under the License, you shall
          have no other rights, expressed or implied, in the Software. Without
          limiting the generality of the foregoing, you agrees and undertakes,
          not to: (a) sell, lease, sublicense or distribute the Software, or any
          part thereof, or otherwise transfer the Software or allow any third
          party to use the Software in any manner; (b) reverse engineer,
          decompile, disassemble or otherwise reduce to human-perceivable form
          the Software&apos;s source code; (c) modify, revise, enhance or alter
          the Software; (d) copy or allow copies of the Software to be made; (e)
          use any backup or archival copies of the Software, or any part
          thereof, or allow any third party to use such copies, for any purpose
          other than to replace an original copy in the event of the destruction
          of the Software components, if the Software becomes defective;; or (f)
          represent that it possesses any proprietary interest in the Software.
        </li>
        <li>
          You shall adhere to the terms of the License Agreement, and shall not
          (a) create or attempt to create by reverse engineering, disassembly,
          decompilation, or otherwise, the source code, (or the underlying
          ideas, algorithms, structure, or organization) from the service, or
          any part thereof, or aid or permit others to do so, except and only to
          the extent expressly permitted by applicable law; (b) remove or alter
          any trademark, logo, copyright or other proprietary notices or
          markings in the service; or (c) copy, modify or create any derivative
          work of, the service or any portion thereof.
        </li>
      </ol>
      <h2>Proprietary Rights </h2>
      <ol>
        <li>
          <b>Title &amp; Ownership.</b> INFINITY DOES NOT SELL OR TRANSFER TITLE
          IN THE SOFTWARE, OR ANY PART THEREOF, TO YOU. The Software and/or any
          copies thereof, including without limitation any derivative works made
          (regardless of whether such derivative works were made and/or
          developed pursuant to the request and/or specifications of any third
          party on its behalf, and irrespective of any support and/or assistance
          Infinity may, will or had received from any third party on its behalf,
          with respect thereto), as well as any Updates thereto, if provided to
          you pursuant to this License Agreement, shall remain Infinity&apos;s
          sole and exclusive property. All Intellectual Property Rights
          evidenced by or embodied in and/or attached/connected/related to the
          Software, or part thereof, are and shall be owned solely and
          exclusively by Infinity. Nothing in this License Agreement shall
          constitute a waiver of Infinity&apos;s Intellectual Property Rights
          under any law, or be in any way construed or interpreted as such.
        </li>
        <li>
          <b>Feedback.</b> It is further agreed that to the extent you provide
          Infinity suggestions, comments or feedback (whether orally or in
          writing) with respect to the Software (the “Feedback”), you
          acknowledge that any and all rights, including Intellectual Property
          Rights in such Feedback shall belong exclusively to Infinity and that
          such shall be considered Infinity&apos;s confidential information. It
          is further understood that use of Feedback, if any, may be made by
          Infinity at its sole discretion, and that Infinity in no way shall be
          obliged to make use of any kind of the Feedback or part thereof. You
          hereby acknowledge such rights and ownership and agree neither to
          challenge such rights or ownership, nor to claim to have any rights or
          interests in Infinity&apos;s (or its licensors) Intellectual Property
          Rights. You shall not alter, change, remove or erase any of
          Infinity&apos;s trademarks, legends, labels or other notices or
          indications that Infinity may affix to Software, without
          Infinity&apos;s prior written approval.
        </li>
        <li>
          <b>Third Party Software.</b> You acknowledge and agree that the
          Software may include third-party software, including certain open
          source code software and materials embedded within, that are subject
          to the terms of the acknowledgements and license applicable thereto,
          details of which are available upon written request. In the event of
          any inconsistencies or conflicting provisions between the provisions
          of open source licenses and the provisions of this License Agreement,
          the provisions of these open source licenses shall prevail. Any such
          third party software is provided “AS IS” without any warranty of any
          kind and shall be subject to any and all limitations and conditions
          required by such third parties. Infinity is not liable for any losses
          or damages which may occur resulting from the use of any third party
          software. The use of the Software and/or the Infinity Materials except
          as expressly permitted hereunder is expressly prohibited and
          constitutes an illegal infringement of copyright and other rights of
          Infinity in and to the Software.
        </li>
        <li>
          <b>Protection.</b> You undertake to make best efforts not to permit
          any third party to, duplicate, modify, or alter the Software, or any
          part thereof in any manner whatsoever, or to assist, directly or
          indirectly, any other entity in such activities. You shall refrain
          from and do its utmost to prevent any harm from being caused to
          Infinity&apos;s Intellectual Property Rights and shall notify Infinity
          of any harm caused or a suspected harm thereto. You may not allow to,
          modify or prepare derivative works of the Software in whole or in
          part. Nothing contained in this License Agreement will be construed as
          conferring by implication, estoppel or otherwise upon you or any third
          party any license or other right except the licenses and rights
          expressly granted hereunder to a party hereto.
        </li>
        <li>
          <b>Third Parties Claims.</b> You shall promptly notify Infinity of any
          claim it receives with respect to the Software, the Infinity Materials
          or any part thereof infringes a third party&apos;s proprietary rights.
          Upon receipt of such notice, Infinity shall, in its sole discretion
          and at its option take actions it deems necessary: (a) defend the
          claim at its expense, with your cooperation, (b) make such changes in
          the Software, the Infinity Materials, or parts thereof to ameliorate
          such alleged infringement, (c) purchase such proprietary right or
          license its use, or (d) refund to you of the purchase price of such
          Software, less a reasonable deduction for its use, wear and tear, and
          depreciation. The foregoing contains the entire liability of Infinity
          to you with respect to infringement of patents or other proprietary
          rights by the Software, the Infinity Materials, or parts thereof, or
          by their operation.
        </li>
        <li>
          <b>Trademarks.</b> No right, title to, or interest in Infinity&apos;s
          trademarks is granted hereunder. You hereby acknowledge Infinity
          rights in Infinity&apos;s trademarks and agrees that any use of
          Infinity&apos;s trademarks shall inure to the sole benefit of
          Infinity. Upon the termination of this License Agreement for any
          reason, you shall immediately cease any use of any trademark, logo,
          brand name or other tradename or other trademark of Infinity.
        </li>
        <li>
          Subject to any licenses expressly granted by Infinity to you under
          this License Agreement, Infinity shall solely own all right, title,
          and interest in and to any data, insights, know-how, Feedbacks,
          application use case, or other data on a de-identified basis (i)
          generated by or on behalf of Infinity through the analysis of user
          data collected by or on behalf of Infinity through the Software
          whether alone or in combination with other data; or (ii) generated by
          Infinity&apos;s use of Feedbacks using the Software.
        </li>
      </ol>
      <h2>AI-Powered Features </h2>
      <p>
        The Software may include features powered by artificial intelligence, including an AI learning assistant. Responses and other content produced by such features are generated automatically and may be inaccurate, incomplete or otherwise unsuitable in particular circumstances. You should use reasonable judgment when relying on AI-generated content. <br />
        Interactions with AI-powered features may be processed, stored and, in appropriate cases, reviewed by authorized personnel and service providers as further described in Infinity&apos;s Privacy Policy. <br />
        You should not submit sensitive personal information, confidential information belonging to third parties, or other information that is not reasonably necessary for your use of the AI-powered feature. <br />
      </p>
      <h2>No Warranty. </h2>
      <ol>
        <li>
          Infinity warrants that the Software meet its standard written
          specifications or descriptions, as they shall be in effect at the time
          of license of such Software for a period of thirty (30) days from the
          date the Software was licensed by Infinity. Infinity&apos;s sole
          obligation in the event of defective Software shall be to repair or
          replace such defective Software, in its sole discretion. Infinity does
          not warrant that the Software shall be error free or that it shall
          meet your requirements. The information made available to you through
          the Software is not intended to be relied on for business or other
          decision making purposes and Infinity assumes no liability whatsoever
          regarding any use of, or reliance on, the information and content in
          the Software.
        </li>
        <li>
          THE WARRANTIES IN THIS LICENSE AGREEMENT WILL NOT APPLY IF THE
          SOFTWARE IS MODIFIED IN ANY WAY, OR USED IN ANY WAY INCONSISTENT WITH
          THIS LICENSE AGREEMENT. THIS SECTION STATES THE SOLE WARRANTY OF
          INFINITY RELATING TO THE SOFTWARE. EXCEPT FOR THE WARRANTY SET FORTH
          ABOVE, THE SOFTWARE IS LICENSED “AS IS”, AND ALL OTHER WARRANTIES,
          CONDITIONS AND REPRESENTATIONS, EXPRESS OR IMPLIED, INCLUDING WITHOUT
          LIMITATION, THE IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE, AND NON-INFRINGEMENT ARE HEREBY EXCLUDED.
        </li>
      </ol>
      <h2>Copyright Indemnity</h2>
      <ol>
        <li>
          You shall indemnify Infinity against all damages, costs, charges and
          expenses arising from or incurred by reason of any of your
          infringement or alleged infringement of copyrights or other
          Intellectual Property Rights of the Software supplied by Infinity
          under this License Agreement, provided that Infinity shall promptly
          notify you in writing of any alleged infringement of which they
          receive notice.
        </li>
        <li>
          You shall hold Infinity harmless, from any type of damages which may
          arise, however caused, and on any theory of liability, whether for
          breach of contract, tort (including negligence and strict liability),
          (i) in the event that you continues using a specific version of the
          Software following a notice by infinity to you to Upgrade this
          specific version of the Software due to a problem with such specific
          version of the Software; or (ii) for any use by you beyond what is
          stated in the terms hereunder.
        </li>
      </ol>

      <h2>Limitation of Liability </h2>
      <ol>
        <li>
          INFINITY, NOR ITS DIRECTORS, EMPLOYEES, REPRESENTATIVES OR RESPECTIVE
          LICENSORS, WILL NOT BE LIABLE FOR ANY INCIDENTAL, INDIRECT, SPECIAL,
          CONSEQUENTIAL, EXEMPLARY OR RELIANCE DAMAGES, LOSSES OR EXPENSES
          (INCLUDING WITHOUT LIMITATION LOSS OF BUSINESS, OR REVENUES OR PROFIT,
          OR COSTS OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, OR OTHER
          ECONOMIC ADVANTAGE, OR LOSS OF DATA OR USE) RELATING TO OR ARISING OUT
          OF THIS EULA AND/OR BY USING THE SOFTWARE, HOWEVER CAUSED, AND WHETHER
          BASED ON CONTRACT, TORT, EQUITY OR ANY OTHER THEORY OF LIABILITY
          WHATSOEVER, EVEN IF SUCH PARTY WAS NOTIFIED OR OTHERWISE AWARE OF THE
          POSSIBILITY OF SUCH DAMAGES, LOSSES OR EXPENSES.
        </li>
        <li>
          WITHOUT DEROGATING FROM THE ABOVE SAID, IN NO EVENT SHALL INFINITY BE
          LIABLE FOR ANY UNFORSEEN DAMAGES, LOSSES OR EXPENSES, UNDER NO
          CIRCUMSTANCES WILL Infinity&apos;s TOTAL AND AGGREGATE LIABILITY TO
          YOU OR TO ANY THIRD PARTY, FROM ALL CAUSES OF ACTION OF ANY KIND,
          INCLUDING WITHOUT LIMITATION CONTRACT, TORT, NEGLIGENCE, STRICT
          LIABILITY, BREACH OF WARRANTY, OR OTHERWISE, ARISING OUT OF OR RELATED
          TO THIS EULA AND/OR THE USE OF THE SOFTWARE, UNDER ANY CIRCUMSTANCES,
          EXCEED THE FEES YOU ACTUALLY PAID FOR THE USE OF THE SOFTWARE IN THE
          TWELVE (12) MONTHS PRECEDING SUCH CLAIM WHICH WILL BE YOUR EXCLUSIVE
          REMEDY.
        </li>
      </ol>

      <h2>Governing Law; Disputes </h2>
      <ol>
        <li>
          This License Agreement, shall be exclusively governed by and construed
          in accordance with the laws of the State of Israel, excluding any
          choice or conflicts of law provision or rule that would cause the
          application of any laws of any other jurisdiction.
        </li>
        <li>
          The Parties will attempt in good faith to resolve any and all claims,
          actions or disputes arising out of or in connection with this License
          Agreement, including (but not limited to) its existence, validity,
          interpretation, performance, breach of termination through
          negotiations, and if cannot be settled amicably within thirty (30)
          days from the date on which either Party has served a written notice
          of the dispute on the other Party, such dispute shall be resolved
          exclusively by the competent courts of Tel Aviv, Israel.
        </li>
      </ol>
      <h2>Term of License</h2>
      <p>
        This EULA is effective until terminated. Your rights under this EULA
        will terminate automatically without notice from Infinity if you fail to
        comply with any term(s) of this EULA. Upon termination of this EULA, you
        must cease all use of the Software and destroy all copies of the
        Software.
      </p>
      <h2>Confidentiality</h2>
      <p>
        Any information relating to the Software and/or any information
        disclosed to you by Infinity, including information in oral, visual or
        computer database (“Confidential Information”), shall be deemed to have
        been furnished in confidence and shall not be used by you for any
        purpose whatsoever other than for the performance hereunder. You shall
        take all necessary precautions and maintain strict safeguards to hold
        such Confidential Information in strict confidence and to prevent the
        disclosure thereof to any third party; and you shall exercise at least a
        degree of care to preserve and safeguard the Confidential Information
        such as that which it would undertake to preserve and safeguard its own
        confidential information.
      </p>
      <h2>Notices</h2>
      <p>
        Any notice, request, demand or other communication required or permitted
        hereunder shall be in writing, shall reference this Agreement and shall
        be deemed to be properly given: (a) when delivered personally; (b) when
        sent by facsimile, with written confirmation of receipt by the sending
        facsimile machine; (c) five (5) business days after having been sent by
        registered or certified mail, return receipt requested, postage prepaid;
        (d) two (2) business days after deposit with an express reputable
        courier, with written confirmation of receipt.
      </p>
      <h2>Entire Agreement</h2>
      <p>
        This EULA constitutes the entire agreement between you and Infinity with
        respect to the Software and supersedes all prior or contemporaneous
        communications and proposals, whether oral or written, between you and
        Infinity regarding the Software.
      </p>
      <h2>Severability</h2>
      <p>
        If any provision of this EULA is held to be invalid or unenforceable,
        such provision shall be struck and the remaining provisions shall be
        enforced.
      </p>
      <h2>Waiver</h2>
      <p>
        The failure of Infinity to enforce any right or provision of this EULA
        shall not be deemed a waiver of such right or provision.
      </p>
      <h2>Acknowledgment</h2>
      <p>
        By installing or using the Software, you acknowledge that you have read
        this EULA, understand it, and agree to be bound by it. You also
        acknowledge and agree that Infinity may use your de-identified
        information for its statistical purposes and for career placement
        services.
      </p>
    </DocumentPage>
  );
};

const EulaRegular = (): JSX.Element => {
  return (
    <DocumentPage>
      <h1>End-User License Agreement</h1>
      <p>
        IMPORTANT &ndash; READ CAREFULLY: This End-User License Agreement
        (&ldquo;
        <b>EULA</b>
        &rdquo;) is a legal agreement between you (either an individual or a
        single entity) and Infinity Labs R&amp;D Ltd. (&ldquo;
        <b>Infinity</b>
        &rdquo;) for the Software(s) (as defined below). By installing or using
        the Software, you agree to be bound by the terms of this EULA. If you do
        not agree to the terms of this EULA, do not install or use the Software.
      </p>
      <h2>Definitions</h2>
      <p>
        All defined terms in this License Agreement shall have the meaning
        assigned to them herein.
      </p>
      <ol>
        <li>
          &ldquo;<b>Intellectual Property Rights</b>&rdquo; means all intangible
          legal rights, titles and interests evidenced by or embodied in all:
          (i) inventions (regardless of patentability and whether or not reduced
          to practice), improvements thereto, patents, patent applications,
          patent disclosures, together with all reissuances, continuations,
          continuations in part, revisions, extensions and reexaminations
          thereof; (ii) trademarks, service marks, trade dress, logos, trade
          names, corporate names, together with translations, adaptations,
          derivations and combinations thereof, including know-how or goodwill
          associated therewith, and applications, registrations, and renewals in
          connection therewith; (iii) any work of authorship, regardless of
          copyrightable, copyrightable works, copyrights (including droit
          morale), and applications, registrations and renewals in connection
          therewith; (iv) mask works and applications, registrations and
          renewals in connection therewith; (v) trade secrets and Confidential
          Information; and (vi) other proprietary rights and any other similar
          rights, in each case on a worldwide basis, and copies and tangible
          embodiments thereof, in whatever form or medium including Confidential
          Information, all industrial and intellectual property rights, and
          includes any patents, inventions, business names, domain names,
          registered designs, copyright (including future copyright), moral
          rights, trade or service marks (whether registered or unregistered),
          trade secrets, know-how, rights in relation to circuit layouts, or
          other proprietary right, and applications for, and rights to apply
          for, registration of any of the foregoing and any renewals, reissues,
          extensions, continuations or divisions thereof, and all other
          intellectual property rights and equivalent or similar forms of
          protection now or hereafter existing anywhere in the world.
        </li>
        <li>
          &ldquo; <b>New Release</b> &rdquo; means an updated version of the
          Software that includes or adds new functionality or adds substantially
          new features to the Software, including any major enhancements, as
          designated by a progression of the version number left of the decimal
          point following the version initially delivered hereunder.
        </li>
        <li>
          &ldquo; <b>Software</b> &rdquo; means the object code version of
          Infinity&rsquo;s proprietary software provided with this EULA, related
          documentation, user manuals, and Updates, and all other written and or
          electronic materials relating thereto.
        </li>
        <li>
          &ldquo;<b>Updates</b> &rdquo; means, with respect to any element of
          the Software, a new version of such element that includes bug fixes
          and minor enhancements to the Software, as designated by a progression
          of the version number right of the decimal point following the version
          initially delivered hereunder, and which is made available at no
          additional cost by Infinity to its customers generally.
        </li>
      </ol>
      <h2>License Grant</h2>
      <ol>
        <li>
          Subject to the terms set forth in this License Agreement, and when
          applicable , upon receipt of payment in full by Infinity, Infinity
          hereby grants you and you accepts, during the term of this License
          Agreement, a non-exclusive, non-transferable, non-sublicensable,
          revocable license limited right to use the Software for internal use
          purposes of you only, in machine-readable object form only (the &quot;
          <b>License</b>&quot;).
        </li>
      </ol>
      <h2>Reservation of Rights; Use Restrictions</h2>
      <ol>
        <li>
          Other than the rights explicitly granted under the License, you shall
          have no other rights, expressed or implied, in the Software. Without
          limiting the generality of the foregoing, you agrees and undertakes,
          not to: (a) sell, lease, sublicense or distribute the Software, or any
          part thereof, or otherwise transfer the Software or allow any third
          party to use the Software in any manner; (b) reverse engineer,
          decompile, disassemble or otherwise reduce to human-perceivable form
          the Software&rsquo;s source code; (c) modify, revise, enhance or alter
          the Software; (d) copy or allow copies of the Software to be made; (e)
          use any backup or archival copies of the Software, or any part
          thereof, or allow any third party to use such copies, for any purpose
          other than to replace an original copy in the event of the destruction
          of the Software components, if the Software becomes defective; or (f )
          use the Software other than with your own computers or for any use
          other than internal use ; and (vii) represent that it possesses any
          proprietary interest in the Software.
        </li>
        <li>
          You shall adhere to the terms of the License Agreement, and shall not
          (a) create or attempt to create by reverse engineering, disassembly,
          decompilation, or otherwise, the source code, (or the underlying
          ideas, algorithms, structure, or organization) from the service, or
          any part thereof, or aid or permit others to do so, except and only to
          the extent expressly permitted by applicable law; (b) remove or alter
          any trademark, logo, copyright or other proprietary notices or
          markings in the service; or (c) copy, modify or create any derivative
          work of, the service or any portion thereof.
        </li>
      </ol>
      <h2>Proprietary Rights </h2>
      <ol>
        <li>
          Title &amp; Ownership . INFINITY DOES NOT SELL OR TRANSFER TITLE IN
          THE SOFTWARE, OR ANY PART THEREOF, TO CUSTOMER. The Software and/or
          any copies thereof , including without limitation any derivative works
          made (regardless of whether such derivative works were made and/or
          developed pursuant to the request and/or yout specifications, and
          irrespective of any support and/or assistance Infinity may, will or
          had received from you, or any third party on its behalf, with respect
          thereto), as well as any Updates thereto, if provided to you pursuant
          to this License Agreement, shall remain Infinity&rsquo;s sole and
          exclusive property. All Intellectual Property Rights evidenced by or
          embodied in and/or attached/connected/related to the Software, or part
          thereof, are and shall be owned solely and exclusively by Infinity.
          Nothing in this License Agreement shall constitute a waiver of
          Infinity&rsquo;s Intellectual Property Rights under any law, or be in
          any way construed or interpreted as such.
        </li>
        <li>
          Feedback . It is further agreed that to the extent you provide
          Infinity suggestions, comments or feedback (whether orally or in
          writing) with respect to the Software (the &ldquo;
          <b>Feedback</b>
          &rdquo;), you acknowledges that any and all rights, including
          Intellectual Property Rights in such Feedback shall belong exclusively
          to Infinity and that such shall be considered Infinity&rsquo;s
          Confidential Information. It is further understood that use of
          Feedback, if any, may be made by Infinity at its sole discretion, and
          that Infinity in no way shall be obliged to make use of any kind of
          the Feedback or part thereof. You hereby acknowledge such rights and
          ownership and agree neither to challenge such rights or ownership, nor
          to claim to have any rights or interests in Infinity&rsquo;s (or its
          licensors) Intellectual Property Rights. You shall not alter, change,
          remove or erase any of Infinity&rsquo;s trademarks, legends, labels or
          other notices or indications that Infinity may affix to Software,
          without Infinity&rsquo;s prior written approval.
        </li>
        <li>
          Third Party Software . You acknowledge and agree that the Software may
          include third-party software, including certain open source code
          software and materials embedded within, that are subject to the terms
          of the acknowledgements and license applicable thereto, details of
          which are available upon written request. In the event of any
          inconsistencies or conflicting provisions between the provisions of
          open source licenses and the provisions of this License Agreement, the
          provisions of these open source licenses shall prevail. Any such third
          party software is provided &ldquo;AS IS&rdquo; without any warranty of
          any kind and shall be subject to any and all limitations and
          conditions required by such third parties. Infinity is not liable for
          any losses or damages which may occur resulting from the use of any
          third party software. The use of the Software except as expressly
          permitted hereunder is expressly prohibited and constitutes an illegal
          infringement of copyright and other rights of Infinity in and to the
          Software.
        </li>
        <li>
          Protection . You undertake to make best efforts not to permit any
          third party to, duplicate, modify, or alter Software, or any part
          thereof in any manner whatsoever, or to assist, directly or
          indirectly, any other entity in such activities. You shall refrain
          from and do its utmost to prevent any harm from being caused to
          Infinity&apos;s Intellectual Property Rights and shall notify Infinity
          of any harm caused or a suspected harm thereto. You may not allow to,
          modify or prepare derivative works of the Software in whole or in
          part. Nothing contained in this License Agreement will be construed as
          conferring by implication, estoppel or otherwise upon you or any third
          party any license or other right except the licenses and rights
          expressly granted hereunder to a party hereto.
        </li>
        <li>
          Third Parties Claims . You shall promptly notify Infinity of any claim
          it receives with respect to the Software, or any part thereof
          infringes a third party&rsquo;s proprietary rights. Upon receipt of
          such notice, Infinity shall, in its sole discretion and at its option
          take actions it deems necessary: (a) defend the claim at its expense,
          with your cooperation, (b) make such changes in the Software, or parts
          thereof to ameliorate such alleged infringement, (c) purchase such
          proprietary right or license its use, or (d) refund to you of the
          purchase price of such Software, less a reasonable deduction for its
          use, wear and tear, and depreciation. The foregoing contains the
          entire liability of Infinity to you with respect to infringement of
          patents or other proprietary rights by the Softwareor parts thereof,
          or by their operation.
        </li>
        <li>
          Trademarks . No right, title to, or interest in Infinity&rsquo;s
          trademarks is granted hereunder. You hereby acknowledge Infinity
          rights in Infinity&rsquo;s trademarks and agrees that any use of
          Infinity&rsquo;s trademarks shall inure to the sole benefit of
          Infinity. Upon the termination of this License Agreement for any
          reason, you shall immediately cease any use of any trademark, logo,
          brand name or other tradename or other trademark of Infinity.
        </li>
        <li>
          Subject to any licenses expressly granted by Infinity to you under
          this License Agreement, Infinity shall solely own all right, title,
          and interest in and to any data, insights, know-how, Feedbacks,
          application use case, or other data on a de-identified basis (i)
          generated by or on behalf of Infinity through the analysis of user
          data collected by or on behalf of Infinity through the Software
          whether alone or in combination with other data; or (ii) generated by
          Infinity&apos;s use of Feedbacks using the Software.
        </li>
      </ol>
      <h2>AI-Powered Features </h2>
      <p>
        The Software may include features powered by artificial intelligence, including an AI learning assistant. Responses and other content produced by such features are generated automatically and may be inaccurate, incomplete or otherwise unsuitable in particular circumstances. You should use reasonable judgment when relying on AI-generated content. <br />
        Interactions with AI-powered features may be processed, stored and, in appropriate cases, reviewed by authorized personnel and service providers as further described in Infinity&apos;s Privacy Policy. <br />
        You should not submit sensitive personal information, confidential information belonging to third parties, or other information that is not reasonably necessary for your use of the AI-powered feature. <br />
      </p>
      <h2>No Warranty</h2>
      <ol>
        <li>
          Infinity warrants that the Software meet its standard written
          specifications or descriptions, as they shall be in effect at the time
          of license of such Software for a period of thirty (30) days from the
          date the Software was licensed by Infinity. Infinity&rsquo;s sole
          obligation in the event of defective Software shall be to repair or
          replace such defective Software, in its sole discretion. Infinity does
          not warrant that the Software shall be error free or that it shall
          meet your requirements. The information made available to you through
          the Software is not intended to be relied on for business or other
          decision making purposes and Infinity assumes no liability whatsoever
          regarding any use of, or reliance on, the information and content in
          the Software.
        </li>
        <li>
          THE WARRANTIES IN THIS LICENSE AGREEMENT WILL NOT APPLY IF THE
          SOFTWARE IS MODIFIED IN ANY WAY, OR USED IN ANY WAY INCONSISTENT WITH
          THIS LICENSE AGREEMENT. THIS SECTION STATES THE SOLE WARRANTY OF
          INFINITY RELATING TO THE SOFTWARE. EXCEPT FOR THE WARRANTY SET FORTH
          ABOVE, THE SOFTWARE IS LICENSED &ldquo;AS IS&rdquo;, AND ALL OTHER
          WARRANTIES, CONDITIONS AND REPRESENTATIONS, EXPRESS OR IMPLIED,
          INCLUDING WITHOUT LIMITATION, THE IMPLIED WARRANTY OF MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT ARE HEREBY
          EXCLUDED.
        </li>
      </ol>
      <h2>Copyright Indemnity</h2>
      <ol>
        <li>
          You shall indemnify Infinity against all damages, costs, charges and
          expenses arising from or incurred by reason of any infringement or
          alleged infringement of copyright or other Intellectual Property
          Rights of any third party in consequence of the authorized use or
          possession of the Software supplied by Infinity under this License
          Agreement, subject to the following: (i) Infinity shall promptly
          notify you in writing of any alleged infringement of which they
          receive notice and (ii) shall not make any admissions without your
          prior written consent.
        </li>
        <li>
          You shall hold Infinity harmless, from any type of damages which may
          arise, however caused, and on any theory of liability, whether for
          breach of contract, tort (including negligence and strict liability),
          (i) in the event that you continues using a specific version of the
          Software following a notice by infinity to you to Upgrade this
          specific version of the Software due to a problem with such specific
          version of the Software; or (ii) for any use by you beyond what is
          stated in the terms hereunder.
        </li>
      </ol>
      <h2>Limitation of Liability </h2>
      <ol>
        <li>
          INFINITY NOR ITS DIRECTORS, EMPLOYEES, REPRESENTATIVES OR RESPECTIVE
          LICENSORS, WILL BE LIABLE FOR ANY INCIDENTAL, INDIRECT, SPECIAL,
          CONSEQUENTIAL, EXEMPLARY OR RELIANCE DAMAGES, LOSSES OR EXPENSES
          (INCLUDING WITHOUT LIMITATION LOSS OF BUSINESS, OR REVENUES OR PROFIT,
          OR COSTS OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, OR OTHER
          ECONOMIC ADVANTAGE, OR LOSS OF DATA OR USE) RELATING TO OR ARISING OUT
          OF THIS AGREEMENT, HOWEVER CAUSED, AND WHETHER BASED ON CONTRACT,
          TORT, EQUITY OR ANY OTHER THEORY OF LIABILITY WHATSOEVER, EVEN IF SUCH
          PARTY WAS NOTIFIED OR OTHERWISE AWARE OF THE POSSIBILITY OF SUCH
          DAMAGES, LOSSES OR EXPENSES.
        </li>
        <li>
          WITHOUT DEROGATING FROM THE ABOVE SAID, IN NO EVENT SHALL INFINITY BE
          LIABLE FOR ANY UNFORSEEN DAMAGES, AND UNDER NO CIRCUMSTANCES WILL
          INFINITY&rsquo;S TOTAL AND AGGREGATE LIABILITY TO YOU OR TO ANY THIRD
          PARTY, FROM ALL CAUSES OF ACTION OF ANY KIND, INCLUDING WITHOUT
          LIMITATION CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, BREACH OF
          WARRANTY, OR OTHERWISE, ARISING OUT OF OR RELATED TO THIS AGREEMENT,
          UNDER ANY CIRCUMSTANCES, EXCEED THE FEES ACTUALLY PAID TO INFINITY
          HEREUNDER IN THE TWELVE (12) MONTHS PRECEDING SUCH CLAIM WHICH WILL BE
          YOUR EXCLUSIVE REMEDY.
        </li>
      </ol>
      <h2>Governing Law; Disputes</h2>
      <ol>
        <li>
          This License Agreement, shall be exclusively governed by and construed
          in accordance with the laws of the State of Israel, excluding any
          choice or conflicts of law provision or rule that would cause the
          application of any laws of any other jurisdiction.
        </li>
        <li>
          The Parties will attempt in good faith to resolve any and all claims,
          actions or disputes arising out of or in connection with this License
          Agreement, including (but not limited to) its existence, validity,
          interpretation, performance, breach of termination through
          negotiations, and if cannot be settled amicably within thirty (30)
          days from the date on which either Party has served a written notice
          of the dispute on the other Party, such dispute shall be resolved
          exclusively by the competent courts of Tel Aviv, Israel.
        </li>
      </ol>
      <h2>Term of License</h2>
      <p>
        This EULA is effective until terminated. Your rights under this EULA
        will terminate automatically without notice from Infinity if you fail to
        comply with any term(s) of this EULA. Upon termination of this EULA, you
        must cease all use of the Software and destroy all copies of the
        Software.
      </p>
      <h2>Notices</h2>
      <p>
        Any notice, request, demand or other communication required or permitted
        hereunder shall be in writing, shall reference this Agreement and shall
        be deemed to be properly given: (a)when delivered personally; (b)when
        sent by via e-mail to info@infinitylabs.co.il, with written confirmation
        of receipt; (c)five (5) business days after having been sent by
        registered or certified mail, return receipt requested, postage prepaid;
        (d)two (2) business days after deposit with an express reputable
        courier, with written confirmation of receipt.
      </p>
      <h2>Entire Agreement</h2>
      <p>
        This EULA constitutes the entire agreement between you and Infinity with
        respect to the Software and supersedes all prior or contemporaneous
        communications and proposals, whether oral or written, between you and
        Infinity regarding the Software.
      </p>
      <h2>Severability</h2>
      <p>
        If any provision of this EULA is held to be invalid or unenforceable,
        such provision shall be struck and the remaining provisions shall be
        enforced.
      </p>
      <h2>Waiver</h2>
      <p>
        The failure of Infinity to enforce any right or provision of this EULA
        shall not be deemed a waiver of such right or provision.
      </p>
      <h2>Acknowledgment</h2>
      <p>
        By installing or using the Software, you acknowledge that you have read
        this EULA, understand it, and agree to be bound by its terms and
        conditions.
      </p>
    </DocumentPage>
  );
};

const Eula = (): JSX.Element => {
  if ('yu' === userDomain) {
    return <EulaYu />;
  }

  return <EulaRegular />;
};

export default Eula;
